<template>
	<div>
		<user-nav-menu
			bg-color="transparent"
			profile-text-color="#ffffff"
			:disable-edit-profile="true"
			:disable-account="true"
			:logo-file-name="tenant.settings.brandImages.headerLogos.app.light"
		></user-nav-menu>
		<v-row align="center" justify="center">
			<v-col cols="11" md="7" sm="7">
				<v-overlay :value="spinning"><v-progress-circular :indeterminate="true"></v-progress-circular></v-overlay>
				<h1 class="create-profile-title justify-center text-center pb-5 pt-5">Complete your profile</h1>
				<notification v-show="showNotification"></notification>
				<progressbar v-show="!showNotification"></progressbar>
				<v-card class="card-rounded elevation-1 mt-3" style="width: 100%; height: auto">
					<v-card-title class="pb-0 pl-1">
						<v-btn
							v-show="context != 'complete-profile-steps' && context != previous_context && previous_context != null"
							text
							color="secondary"
							style="font-family: Montserrat; font-style: normal; font-weight: bold"
							@click="goBack"
							><v-icon left color="secondary">mdi-chevron-left</v-icon>Back</v-btn
						>
					</v-card-title>

					<component :is="context ? context : 'v-card'" :required_forms="required_forms"></component>

					<v-card-actions align="center" justify="center" class="justify-center text-center">
						<v-container>
							<v-row align="center" justify="center">
								<v-col cols="12" sm="12" md="12">
									<v-btn
										:v-show="show_button"
										:loading="spinning"
										large
										class="text-none button-rounded continue-signup-button"
										:height="54"
										:color="button_color"
										@click="SubmitForm()"
										>{{ button_text }}<v-icon>mdi-chevron-right</v-icon></v-btn
									>
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="12" sm="12" md="12">
									<v-btn
										v-show="showSkip"
										class="pt-0 mt-0"
										text
										link
										color="primary"
										style="
											font-family: Montserrat;
											font-style: normal;
											font-weight: normal;
											font-size: 11px;
											line-height: 17px;
											text-align: right;
											text-decoration-line: underline;
										"
										@click="$router.push('/')"
									>
										I’ll do this later, skip to dashboard
									</v-btn>
									<v-card-text v-show="!showSkip && this.context == 'complete-profile-steps'">
										Complete the required steps to proceed to your dashboard.
									</v-card-text>
								</v-col>
							</v-row>
						</v-container>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import { bus } from '@/main';
// import { Auth } from 'aws-amplify'
// import axios from 'axios';
import store from '@/store';

import CompleteProfileSteps from '@/components/practice/profile/CompleteProfileStepsForm.vue';
import progressbar from '@/components/practice/complete profile steps/progressbar.vue';
import notification from '@/components/practice/complete profile steps/notification.vue';

import addressStep from '@/components/practice/complete profile steps/Address.vue';
import operationsStep from '@/components/practice/complete profile steps/Operations.vue';
import aboutStep from '@/components/practice/complete profile steps/About.vue';
import completedStep from '@/components/practice/complete profile steps/CompletedStep.vue';
import UserNavMenu from '@/components/user/UserNavMenu';

import { Tracking } from '@/utils';

// import calendarStep from '../components/locum/complete profile steps/CalendarStep.vue';

export default {
	components: {
		CompleteProfileSteps,
		addressStep,
		operationsStep,
		aboutStep,
		UserNavMenu,
		// AboutStep,

		// calendarStep,

		completedStep,

		progressbar,
		notification,
	},
	data: () => ({
		topcard: 'progressbar',
		showNotification: false,
		// button_text : "None",
		// button_color : "primary",
		button_state: false,
		show_button: true,
		spinning: false,
		button_loading: false,
		previous_context: null,
	}),
	computed: {
		company: () => store.getters.company,
		required_forms: () => store.getters.stepsRequiredCompany,
		context: () => store.getters.currentStepCompany,
		next_step: () => store.getters.getNextSignupStepCompany,
		showSkip: function () {
			return store.getters.getNextSignupStepCompany === false && store.getters.getIsApprovedCompany;
		},
		next_step_context: function () {
			const next_step = this.next_step;
			if (next_step != false) {
				return next_step.context;
			} else if (next_step == false) {
				return 'completed-step';
			} else {
				alert('unknown ' + (next_step != false ? next_step.context : 'no next_step') + '| current :' + this.context);
				return false;
			}
		},
		button_text: function () {
			const next_step = this.next_step;
			if (next_step != false) {
				if (this.context != next_step.context) {
					// alert("something broke. please contact an admin. error code - SC01-p");
					return 'Continue to ' + next_step.button_text;
				} else {
					return 'Continue to ' + next_step.button_text;
				}
			} else if (next_step == false) {
				if (this.context == 'completed-step') {
					return this.getLabel('companyCompleteProfileCompleteButton', 'Find locums');
				} else {
					return this.getLabel('companyProfileUnlockButton', 'Unlock your practice profile');
				}
			} else {
				alert('something broke. please contact an admin. error code - UNK01');
				return 'unknown ' + (next_step != false ? next_step.context : 'no next_step') + '| current :' + this.context;
			}
		},
		button_color: function () {
			const next_step = this.next_step;
			if (next_step != false) {
				if (this.context != next_step.context) {
					return 'primary';
				} else {
					return 'primary';
				}
			} else if (next_step == false) {
				if (this.context == 'completed-step') {
					return 'primary';
				} else {
					return '#63C367';
				}
			} else {
				return '#F21';
			}
		},
	},

	async mounted() {
		bus.$on('intent:previous-context', () => {
			store.commit('SET_STEP_COMPANY', this.previous_context);
			bus.$emit('steps@refresh');
		});
		bus.$on('intent:change-context', new_context => {
			this.previous_context = this.context;
			store.commit('SET_STEP_COMPANY', new_context); //get the state and commit.
			bus.$emit('steps@refresh');
		});

		bus.$on('update:spinning', value => {
			this.spinning = value;
		});

		bus.$on('update:topcard', topcard => {
			this.topcard = topcard == 'progressbar' || topcard == 'notification' ? topcard : 'progressbar';
		});

		bus.$on('push:notification@hide', () => {
			this.showNotification = false; //hide it.
		});

		bus.$on('push:notification@show', () => {
			this.showNotification = true; //show it.
		});

		bus.$on('steps@refresh', async () => {
			await this.Update();
		});

		bus.$on('intent:next-step', requestee => {
			if (this.context == requestee) {
				this.NextStepRequested();
			} else {
				console.error(['request for context change by non owner form', requestee, this.context]);
			}
		});
		bus.$on('update:next-button-text', text => {
			this.UpdateSubmitButtonText(text);
		});
		bus.$on('update:next-button-color', color => {
			this.UpdateSubmitButtonColor(color);
		});
		bus.$on('update:next-button-enable', state => {
			this.UpdateSubmitButtonState(state);
		});
		bus.$on('update:next-button-loading', state => {
			this.UpdateSubmitButtonLoading(state);
		});

		bus.$emit('steps@refresh');
	},

	created() {},

	beforeDestroy() {
		bus.$off('intent:previous-context');
		bus.$off('intent:change-context');

		bus.$off('update:spinning');

		bus.$off('update:topcard');

		bus.$off('push:notification@hide');

		bus.$off('push:notification@show');

		bus.$off('steps@refresh');

		bus.$off('intent:next-step');

		bus.$off('update:next-button-text');

		bus.$off('update:next-button-color');

		bus.$off('update:next-button-enable');
	},

	methods: {
		goBack() {
			bus.$emit('intent:previous-context');
		},
		SubmitForm() {
			bus.$emit('intent:submit-forms' + ':' + this.context); //submit the form, the form is expected to fire the 'next-step' intent when done.
			let Current_step = this.context;
			Tracking.track('Practice_SignUp_Next_Step', { Current_step });
		},
		UpdateSubmitButtonText(text) {
			this.button_text = text;
		},
		UpdateSubmitButtonColor(color) {
			this.button_color = color;
		},
		UpdateSubmitButtonState(state) {
			this.button_state = state;
		},
		UpdateSubmitButtonLoading(state) {
			this.button_loading = state;
		},

		async NextStepRequested() {
			store.commit('SET_STEP_COMPANY', this.next_step_context);
			bus.$emit('steps@refresh');
		},

		async Update() {
			store.dispatch('UPDATE_NEXT_SIGNUP_STEP_COMPANY');
			// sets the status of all steps and then sets the next sign up step

			let practiceApproved = true; //store.getters.getIsApproved;

			if (practiceApproved === false) {
				bus.$emit('push:notification@update', {
					title: 'Account created!',
					subtitle: 'We’re busy verifying your information. In the meanwhile please complete your profile so we can start matching you to amazing locums.',
					avatar: true,
					//disabled action as per garretts request ->
					// actions : [
					//   {text : "force approve locum", onclick : ()=>{
					//     store.dispatch("ApproveProfessional");
					//     bus.$emit("steps@refresh"); //refresh the steps to update the state.
					//   }}
					// ]
				});
				bus.$emit('push:notification@show');
				bus.$emit('update:verification-step@status', 'busy');
			} else {
				bus.$emit('push:notification@hide'); //Hides the notification pop up
			}

			let next_step = store.getters.getNextSignupStepCompany; // gets object of next incomplete step

			//Determine whether to show the Congrats notification
			if (next_step != false && store.getters.currentStepCompany != next_step.context) {
				//indicates that we do have a next step
			} else if (next_step == false && store.getters.currentStepCompany == 'complete-profile-steps') {
				bus.$emit('push:notification@update', {
					title: 'Congrats! You’re profile is live.',
					subtitle: 'You’re now visible to practices and will soon be receiveing offers. Complete your profile to get more visibility and better offer matched. ',
					avatar: true,
				});
				bus.$emit('push:notification@show');
			}
		},
	},
};
</script>
